import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    coverImage: {
      overflow: "hidden",
      width: "fit-content",
      marginBottom: "8px",
    },
    qty: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "17px",
      marginTop: "10px",
      marginBottom: "8px",
      "& span": {
        color: theme?.palette?.basic?.danger_red,
      },
    },
  }),
  { name: "CreatorTool" }
);
